import axios from 'axios';
import { Store } from '../types';
import { Geolocation } from '../hooks/useGeolocation';

export const storeService = {
  async getNearbyStores(userLocation: Geolocation): Promise<Store[]> {
    // TODO: Replace with actual API call
    return [
      {
        id: '1',
        name: 'Sample Store 1',
        address: '123 Main St',
        latitude: userLocation.latitude + 0.01,
        longitude: userLocation.longitude + 0.01,
        payout: 50,
        status: 'open',
        userId: undefined,
      },
      {
        id: '2',
        name: 'Sample Store 2',
        address: '456 Oak Ave',
        latitude: userLocation.latitude - 0.01,
        longitude: userLocation.longitude - 0.01,
        payout: 75,
        status: 'accepted',
        userId: 'user123',
      },
      {
        id: '3',
        name: 'Sample Store 3',
        address: '789 Pine St',
        latitude: userLocation.latitude + 0.02,
        longitude: userLocation.longitude - 0.02,
        payout: 100,
        status: 'completed',
        userId: 'user456',
      },
      {
        id: '4',
        name: 'Sample Store 4',
        address: '321 Elm St',
        latitude: userLocation.latitude + 0.03,
        longitude: userLocation.longitude + 0.03,
        payout: 60,
        status: 'waiting_for_approval',
        userId: 'user789',
      },
      {
        id: '5',
        name: 'Sample Store 5',
        address: '654 Maple Ave',
        latitude: userLocation.latitude - 0.02,
        longitude: userLocation.longitude + 0.02,
        payout: 80,
        status: 'waiting_for_approval',
        userId: 'user789',
      },
      {
        id: '6',
        name: 'Sample Store 6',
        address: '987 Birch St',
        latitude: userLocation.latitude + 0.04,
        longitude: userLocation.longitude - 0.03,
        payout: 90,
        status: 'completed',
        userId: 'user101',
      },
      {
        id: '7',
        name: 'Corner Market',
        address: '159 Oak Lane',
        latitude: userLocation.latitude - 0.03,
        longitude: userLocation.longitude - 0.04,
        payout: 70,
        status: 'waiting_for_approval',
        userId: 'user202',
      },
      {
        id: '8',
        name: 'Downtown Grocery',
        address: '753 Central Blvd',
        latitude: userLocation.latitude + 0.05,
        longitude: userLocation.longitude + 0.01,
        payout: 85,
        status: 'waiting_for_approval',
        userId: 'user303',
      }
    ];
  },

  async acceptCheckIn(storeId: string): Promise<void> {
    try {
      await axios.post(`/api/stores/${storeId}/accept`);
    } catch (error) {
      throw new Error('Failed to accept check-in');
    }
  },

  async getStoreDetails(storeId: string): Promise<Store> {
    try {
      const response = await axios.get(`/api/stores/${storeId}`);
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch store details');
    }
  },
};
